import { memo, useContext, useEffect, useRef } from 'react';
import cn from 'classnames';
import { IContent } from 'src/interface';
import { Element, Icon } from 'src/components';
import LikeButton from 'src/modules/shared/components/buttons/LikeButton';
import FacebookButton from 'src/modules/shared/components/buttons/FacebookButton';
import { ContentDetailContext } from 'src/pages/content/detail/[id]';

interface IProps {
    content?: IContent;
    url?: string;
    id: number;
    contentId: number;
    title: string;
}

const ContentSocial = ({ url, id, contentId, title }: IProps) => {
    const { register, release } = useContext(ContentDetailContext);
    const canRenderRef = useRef(null);
    if (canRenderRef.current === null) {
        canRenderRef.current = register('ContentSocial', id);
    }

    useEffect(() => {
        return () => {
            canRenderRef.current = null;
            release('ContentSocial', id);
        };
    }, [release]);

    if (!canRenderRef.current) return null;
    
    if (!contentId) {
        return null;
    }
    return (
        <Element className={cn('content-social', 'flex gap-[4px]')}>
            <FacebookButton
                className={cn(
                    'w-[32px] h-[32px]',
                    'flex items-center justify-center',
                    'text-[14px]',
                    'rounded-full',
                    'border border-solid border-[#dee2e6]',
                    'text-[#4d4d4d]',
                )}
                link={url}
                title={title}
            >
                <Icon icon="new-facebook-light" />
            </FacebookButton>
            <LikeButton
                contentId={contentId}
                className={cn(
                    'w-[32px] h-[32px]',
                    'flex items-center justify-center',
                    'text-[14px]',
                    'rounded-full',
                    'border border-solid border-[#dee2e6]',
                    'text-[#4d4d4d]',
                    '[&_span]:hidden',
                )}
                text="Like"
                icon="new-thumb-light"
            />
        </Element>
    );
};

export default memo(ContentSocial);
